import {createAsyncThunk} from '@reduxjs/toolkit';
import {AxiosInstance, AxiosResponse} from 'axios';
//enum
import {ACTION_TYPE} from '../actions-types';
//types
import {
	IGetTeamResData,
	ITeamCreateMemberReqBody,
	ITeamReqData,
	ITeamUpdateData,
	IUpdateReqData,
} from '../../utils/types';
//services
import {OrganizationTeamService} from '@/utils/services/organization-team.service';
//helpers
import {getErrorResponse} from '@/utils/helpers';

export const createTeamMember = createAsyncThunk(
	ACTION_TYPE.TEAM_CREATE_MEMBER,
	async (reqBody: ITeamCreateMemberReqBody, {rejectWithValue}) => {
		try {
			await OrganizationTeamService.createTeamMember(reqBody);
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const deleteTeamMember = createAsyncThunk(
	ACTION_TYPE.TEAM_DELETE_MEMBER,
	async (id: number, {rejectWithValue}) => {
		try {
			await OrganizationTeamService.deleteTeamMember(id);
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const updateMemberRole = createAsyncThunk(
	ACTION_TYPE.TEAM_UPDATE_MEMBER_ROLE,
	async ({id, role}: IUpdateReqData, {rejectWithValue}) => {
		try {
			await OrganizationTeamService.updateTeamRole(id, role);
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const createTeamMemberPassword = createAsyncThunk(
	ACTION_TYPE.TEAM_GENERATE_PASSWORD,
	async (_, {rejectWithValue}) => {
		try {
			const teamResponse: AxiosResponse<string> = await OrganizationTeamService.generateTeamMemberPassword();

			return teamResponse.data;
		} catch (error) {
			return rejectWithValue(getErrorResponse(error));
		}
	}
);

export const getTeamMembers = createAsyncThunk(ACTION_TYPE.TEAM, async ({reqBody, apiInstance}: {reqBody: ITeamReqData; apiInstance: AxiosInstance}, {rejectWithValue}) => {
	try {
		const teamResponse: AxiosResponse<IGetTeamResData> = await OrganizationTeamService.getTeam(reqBody, apiInstance);

		return teamResponse.data;
	} catch (error) {
		return rejectWithValue(getErrorResponse(error));
	}
});
